import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    Flex,
    Text,
    Image,
    IconButton,
    HStack,
    VStack,
    useToast,
    Box
} from '@chakra-ui/react';
import { FaTimes, FaCopy } from 'react-icons/fa';
import { Trans } from '@lingui/macro';
import { Large } from '../../components/Type';
import NextImage from "next/image";
import WhatsappIcon from '../../assets/whatsapp_icon.svg';
import FacebookIcon from '../../assets/facebook_icon.svg';
import TelegramIcon from '../../assets/telegram_icon.svg';
import XIcon from '../../assets/x_icon.svg';
import { useClipboard } from 'use-clipboard-copy';
import { t } from '@lingui/macro';
import React from 'react';
import { HOSTNAME } from '../../utils/request'; // Pastikan path sesuai

// Fungsi untuk mengganti base domain
function replaceBaseDomain(url) {
    if (!url) return '';
    try {
        const parsed = new URL(url);
        return url.replace(parsed.origin, HOSTNAME);
    } catch {
        return url;
    }
}

const ShareModal = ({ isOpen, onClose, wishlist, fonts, username }) => {
    const { titleFont, bodyFont } = fonts;
    const toast = useToast();
    const clipboard = useClipboard();
    const publicUrl = replaceBaseDomain(wishlist?.public_url);


    const shareText = `Dukung ${username} mendapatkan ${wishlist?.product_name} di Saweria`;

    const handleShare = (platform) => {
        const shareMessage = `Dukung ${username} mendapatkan ${wishlist?.product_name} di Saweria`;
        const encodedMessage = encodeURIComponent(shareMessage);
        const encodedUrl = encodeURIComponent(publicUrl || '');
        const encodedFullText = encodeURIComponent(`${shareMessage} ${publicUrl}`);

        let url = '';

        switch (platform) {
            case 'whatsapp':
                url = `https://api.whatsapp.com/send?text=${encodedFullText}`;
                break;
            case 'facebook':
                url = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedMessage}`;
                break;
            case 'telegram':
                url = `https://t.me/share/url?url=${encodedUrl}&text=${encodedMessage}`;
                break;
            case 'x':
                url = `https://twitter.com/intent/tweet?text=${encodedMessage}&url=${encodedUrl}`;
                break;
        }

        if (url) {
            window.open(url, '_blank');
        }
    };

    const handleCopy = async () => {
        clipboard.copy(publicUrl);
        toast({
            title: t`Link berhasil disalin!`,
            description: '',
            status: "success",
            duration: 3000,
            isClosable: true,
            position: "top",
        });
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent borderRadius="6px" maxW="500px">
                <ModalHeader fontSize="18px" fontWeight="bold" px={6} pt={4}>
                    <Flex align="center" justify="space-between">
                        <Large fontSize="xl" fontWeight="normal" fontFamily={titleFont}>
                            <Trans>Share Wishlist Ini</Trans>
                        </Large>
                        <IconButton
                            icon={<FaTimes />}
                            size="sm"
                            variant="ghost"
                            onClick={onClose}
                            aria-label="Close"
                        />
                    </Flex>
                </ModalHeader>

                <ModalBody px={6} pb={6}>
                    <VStack spacing={5} align="stretch">
                        <Flex
                            borderRadius="6px"
                            bg="white"
                            border="0.7px solid #a8aaaa"
                            p={3}
                            align="center"
                            gap={3}
                        >
                            <Image
                                src={wishlist?.image_url}
                                alt={wishlist?.product_name}
                                w="63px"
                                h="63px"
                                borderRadius="8px"
                                objectFit="cover"
                            />
                            <Text flex={1} ml={6} lineHeight="20px" fontFamily={bodyFont}>
                                {wishlist?.product_name}
                            </Text>
                        </Flex>

                        <VStack spacing={2} align="stretch">
                            <Text lineHeight="20px" fontWeight="500" fontFamily={bodyFont}>
                                <Trans>Share ke</Trans>
                            </Text>
                            <HStack spacing={2}>
                                <Box cursor="pointer" onClick={() => handleShare('whatsapp')}>
                                    <NextImage src={WhatsappIcon} width={40} height={40} alt="WhatsApp" />
                                </Box>
                                <Box cursor="pointer" onClick={() => handleShare('facebook')}>
                                    <NextImage src={FacebookIcon} width={40} height={40} alt="Facebook" />
                                </Box>
                                <Box cursor="pointer" onClick={() => handleShare('telegram')}>
                                    <NextImage src={TelegramIcon} width={40} height={40} alt="Telegram" />
                                </Box>
                                <Box cursor="pointer" onClick={() => handleShare('x')}>
                                    <NextImage src={XIcon} width={40} height={40} alt="X" />
                                </Box>
                            </HStack>
                        </VStack>

                        <Flex
                            borderRadius="8px"
                            bg="#eaefed"
                            p={3}
                            align="center"
                            gap={4}
                        >
                            <Text
                                flex={1}
                                lineHeight="20px"
                                overflow="hidden"
                                textOverflow="ellipsis"
                                whiteSpace="nowrap"
                                fontFamily={bodyFont}
                            >
                                {publicUrl}
                            </Text>
                            <IconButton
                                icon={<FaCopy />}
                                size="sm"
                                variant="ghost"
                                onClick={handleCopy}
                                aria-label="Copy"
                            />
                        </Flex>
                    </VStack>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default ShareModal;
